// 路由切换防抖时间（毫秒）- 等用户停止按键后再执行路由跳转
export const NAV_DEBOUNCE_DELAY = 300;

// 焦点检查间隔（毫秒）- 使用 16ms（约 1 帧）确保及时清除高亮
export const FOCUS_CHECK_INTERVAL = 16;

// 路由变化后设置焦点的延迟（毫秒）
export const ROUTE_FOCUS_DELAY = 300;

// 导航项滚动延迟（毫秒）
export const NAV_SCROLL_DELAY = 50;

// 滚动后更新状态的延迟（毫秒）
export const SCROLL_UPDATE_DELAY = 500;

// DOM 更新延迟（毫秒）
export const DOM_UPDATE_DELAY = 250;

// 导航项滚动的内边距（像素）
export const NAV_SCROLL_PADDING = 20;

// 滚动阈值（像素）- 避免浮点误差导致的误判
export const SCROLL_THRESHOLD = 1;
